import { useTranslation } from 'react-i18next';
import React, { useEffect } from 'react';
import cx from 'clsx';
import styles from './index.module.scss';
import { IconSwitch } from '@/components';

export const OriginalSwitch = ({
  isOriginal,
  onChange,
  disabled,
}: {
  isOriginal: boolean;
  onChange: (isOriginal: boolean) => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (disabled) {
      onChange(false);
    }
  }, [disabled, onChange]);

  return (
    <div className={styles.originSwitchContainer}>
      <div className={styles.header}>
        <div className={cx(styles.headerText, disabled && styles.disabled)}>
          {!disabled ? t('OriginalSwitch.1k7xgkd') : t('OriginalSwitch.7hcglx')}
        </div>
        <IconSwitch on={isOriginal} onChange={onChange} disabled={disabled} />
      </div>
      <div className={styles.desc}>
        {!disabled ? t('OriginalSwitch.1pocy3t') : t('OriginalSwitch.1sx7rop')}
      </div>
    </div>
  );
};
